module.exports = __webpack_public_path__ + "img/LV3.d040e7bd.webp";